import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, take } from 'rxjs';
import { AppState, IDomainMessage } from '../lemans-app.model';
import { disconnect, retrySignalRConnection, setDomainMessageReceived } from './signalr.actions';
import {
  ensureIsConnectedSelector$,
  selectConnectionState,
  selectDomainMessage,
  selectLastError,
} from './signalr.selectors';
@Injectable({
  providedIn: 'root',
})
export class SignalRFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  domainMessage$ = this.store$.select(selectDomainMessage).pipe(filter((domainMessage) => domainMessage !== undefined));
  isHubConnected$ = this.ensureHubIsConnected$().pipe(take(1));
  connectionState$ = this.store$.select(selectConnectionState);
  lastError$ = this.store$.select(selectLastError);

  private ensureHubIsConnected$(maxWait?: number): Observable<unknown> {
    return ensureIsConnectedSelector$(this.store$, maxWait ?? 20000);
  }

  retryHubConnection(): void {
    this.store$.dispatch(retrySignalRConnection());
  }

  disconnect(): void {
    this.store$.dispatch(disconnect());
  }

  setDomainMessageReceived(domainMessage: IDomainMessage): void {
    this.store$.dispatch(setDomainMessageReceived({ payload: domainMessage }));
  }
}
